import { render, staticRenderFns } from "./app-layout.vue?vue&type=template&id=a0a1cf94&scoped=true&"
import script from "./app-layout.vue?vue&type=script&lang=js&"
export * from "./app-layout.vue?vue&type=script&lang=js&"
import style0 from "./app-layout.vue?vue&type=style&index=0&id=a0a1cf94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a1cf94",
  null
  
)

export default component.exports